import { render } from "./CircleButton.vue?vue&type=template&id=65c8dfce&scoped=true"
import script from "./CircleButton.vue?vue&type=script&lang=js"
export * from "./CircleButton.vue?vue&type=script&lang=js"

import "./CircleButton.vue?vue&type=style&index=0&id=65c8dfce&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8dfce"]])

export default __exports__